import React, { useState } from 'react';
import { Button } from '../../components/ui/Button';
export function RequestQuoteSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    partsNeeded: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <div id="Request_Quote" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 scroll-mt-20" data-id="element-1706">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8 md:p-10" data-id="element-1707">
        <h2 className="text-3xl font-bold text-navy text-center mb-2" data-id="element-1708">
          Request a Quote
        </h2>
        <p className="text-gray-600 text-center mb-8" data-id="element-1709">
          Fill out the form below for EDM parts and consumables pricing.
        </p>

        {submitted ? <div className="text-center py-8" data-id="element-1710">
            <div className="text-green-600 text-5xl mb-4" data-id="element-1711">✓</div>
            <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-1712">
              Quote Request Sent!
            </h3>
            <p className="text-gray-700 text-lg" data-id="element-1713">
              Thank you for your request. Our parts department will contact you
              shortly.
            </p>
          </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1714">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-1715">
              <div data-id="element-1716">
                <label className="block text-sm font-bold text-navy mb-1" data-id="element-1717">
                  Name *
                </label>
                <input type="text" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy" data-id="element-1718" />
              </div>
              <div data-id="element-1719">
                <label className="block text-sm font-bold text-navy mb-1" data-id="element-1720">
                  Company
                </label>
                <input type="text" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy" data-id="element-1721" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-1722">
              <div data-id="element-1723">
                <label className="block text-sm font-bold text-navy mb-1" data-id="element-1724">
                  Email *
                </label>
                <input type="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy" data-id="element-1725" />
              </div>
              <div data-id="element-1726">
                <label className="block text-sm font-bold text-navy mb-1" data-id="element-1727">
                  Phone
                </label>
                <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy" data-id="element-1728" />
              </div>
            </div>
            <div data-id="element-1729">
              <label className="block text-sm font-bold text-navy mb-1" data-id="element-1730">
                Parts/Consumables Needed *
              </label>
              <textarea name="partsNeeded" required rows={4} placeholder="Please list the parts, wire, filters, or other consumables you need quoted..." value={formData.partsNeeded} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy resize-vertical" data-id="element-1731" />
            </div>
            <div className="pt-2" data-id="element-1732">
              <Button type="submit" variant="primary" size="lg" className="w-full md:w-auto md:px-12" data-id="element-1733">
                Submit Request
              </Button>
            </div>
          </form>}
      </div>
    </div>;
}